import moment from 'moment';

export default class License {
  constructor({ id, rowNum, fileName, fileUrl, storeid, storeName, submittedByName, createdAt, startDate, endDate }) {
    this.id = id;
    this.rowNum = rowNum || '';
    this.fileName = fileName || 'NA';
    this.fileUrl = fileUrl || 'NA';
    this.storeid = storeid || 'NA';
    this.storeName = storeName || 'NA';
    this.startDate = startDate || null;
    this.endDate = endDate || null;
    this.submittedByName = submittedByName || '';
    this.createdAt = createdAt ? moment(createdAt).format('DD-MM-YYYY') : null;
  }
}
